<div class="new-aircraft-content">
    <div>
        <mat-form-field>
            <input
                [(ngModel)]="data.tailNumber"
                aria-label="Tail Number"
                cdkFocusInitial
                matInput
                placeholder="Tail Number"
            />
        </mat-form-field>
    </div>
    <div>
        <app-autocomplete-search
            label="Aircraft Make/Model"
            [optionValue]="['make', 'model']"
            [options]="aircraftTypes"
            [displayFn]="displayAircraft"
            (selectionChanged)="onAircraftTypeChanged($event)"
        ></app-autocomplete-search>
    </div>
</div>
<div class="dialog-actions">
    <button
        [disabled]="!data?.tailNumber || !data?.selectedAircraft"
        (click)="onAddAircraftClick()"
        class="mr-1"
        color="accent"
        mat-flat-button
    >
        Add Aircraft
    </button>
    <button (click)="onCancelClick()" mat-stroked-button>Cancel</button>
</div>
